/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import ViewerButton from './ViewerButton';

const Containter = styled.div`
  color: black;

  position: absolute;
  padding: 10px 0 0 10px;
  right: 10px;
  bottom: 60px;
`;

const FullScreenControls = ({ isInFullScreen, enterFullScreenHandler, exitFullScreenHandler }) => {
  const renderButton = () => {
    if (isInFullScreen) {
      return (
        <ViewerButton
          icon={'/iiifimages/minimize.svg'}
          onClickHandler={exitFullScreenHandler}
          titleText="exit fullscreen"
        />
      );
    }

    return (
      <ViewerButton
        icon={'/iiifimages/expand.svg'}
        onClickHandler={enterFullScreenHandler}
        titleText="enter fullscreen"
      />
    );
  };

  return <Containter data-testid="fullscreen-controls">{renderButton()}</Containter>;
};

FullScreenControls.propTypes = {
  isInFullScreen: PropTypes.bool.isRequired,
  enterFullScreenHandler: PropTypes.func.isRequired,
  exitFullScreenHandler: PropTypes.func.isRequired,
};

export default FullScreenControls;
